export default "__VITE_ASSET__iNC7icZR__"